class FreeShippingBar extends HTMLElement {
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.cartData?.total_price !== undefined) {
        this.updateBar(event.cartData.total_price);
      } else {
        this.refresh();
      }
    });

    const cartItems = document.querySelector('#CartDrawer-CartItems') || document.querySelector('#main-cart-items');
    if (cartItems) {
      this.observer = new MutationObserver(() => this.refresh());
      this.observer.observe(cartItems, { childList: true, subtree: true });
    }

    this.refresh();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.cartUpdateUnsubscriber?.();
  }

  refresh() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then(({ total_price }) => this.updateBar(total_price));
  }

  updateBar(total_price) {
    const threshold = parseInt(this.dataset.threshold, 10);
    const remaining = threshold - total_price;
    const percent = Math.min(100, Math.round((total_price / threshold) * 100));

    this.querySelector('[data-bar-fill]').style.width = `${percent}%`;
    this.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', percent);

    const message = this.querySelector('[data-bar-message]');
    if (remaining <= 0) {
      this.classList.add('free-shipping-bar--complete');
      message.textContent = "You've unlocked free shipping!";
    } else {
      this.classList.remove('free-shipping-bar--complete');
      message.textContent = `Add ${this.formatMoney(remaining)} more for free shipping`;
    }
  }

  formatMoney(cents) {
    const format = this.dataset.moneyFormat || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    return format
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', String(Math.round(cents / 100)));
  }
}

customElements.define('free-shipping-bar', FreeShippingBar);
